import { render, staticRenderFns } from "./LCanvasMarker.vue?vue&type=template&id=73ae465b&"
import script from "./LCanvasMarker.vue?vue&type=script&lang=js&"
export * from "./LCanvasMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LCanvasMarker.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports